import Vue from "vue";
import moment from "moment";

const toCurrency = (value, decimals = 2) => {
  if (typeof value === "string") {
    // eslint-disable-next-line no-param-reassign
    value = parseFloat(value);
  }

  const formatter = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    useGrouping: true,
    minimumFractionDigits: decimals,
  });

  return formatter.format(value);
};

const toPercentage = (value, decimals = 5) => {
  if (typeof value !== "number") {
    return value;
  }
  return `${value.toFixed(decimals)} %`;
};

const toDate = (value, format = "DD-MM-YYYY") => (
  moment(value).isValid() ? moment(value).format(format) : value
);

Vue.filter("toCurrency", toCurrency);

Vue.filter("toPercentage", toPercentage);

Vue.filter("toDate", toDate);

Vue.filter("toYesNo", (value) => {
  if (typeof value === "boolean") {
    return value === true ? "Ja" : "Nee";
  }
  if (typeof value === "number") {
    return value === 1 ? "Ja" : "Nee";
  }
  return value;
});

Vue.filter("toSurface", (value, scope = "m") => {
  if (value === null || typeof value === "undefined") {
    return value;
  }

  return `${value} ${scope}²`;
});

Vue.filter("toVolume", (value, scope = "m") => {
  if (value === null || typeof value === "undefined") {
    return value;
  }

  return `${value} ${scope}³`;
});

Vue.filter("toEnergy", (value) => {
  if (value === null || typeof value === "undefined") {
    return value;
  }

  return `${value} kWh`;
});

// eslint-disable-next-line no-unused-vars
function pad(num, size) {
  // eslint-disable-next-line no-param-reassign
  num = num.toString();
  // eslint-disable-next-line no-param-reassign
  while (num.length < size) num = `0${num}`;
  return num;
}

export {
  toCurrency,
  toPercentage,
  toDate,
};
